//factory.js
//convenience utilities for initializing api services

function initService(ep) {
  const serviceHelpers = {
    // init,
    // http,
    // appSessionStore
  };

  serviceHelpers.init = ({ config, core, helpers }) => {
    serviceHelpers.http = core.http;
    serviceHelpers.appSessionStore = helpers.appSessionStore;
    ep.init(config);
  };

  return serviceHelpers;
}

function initEndpoints() {
  const endpointHelpers = {
    // init,
    // BASE_URL,
  };

  endpointHelpers.init = (config) => {
    endpointHelpers.BASE_URL = config.BASE_URL;
    endpointHelpers.OAUTH_URL = config.OAUTH.URL;
  };

  return endpointHelpers;
}

export default {
  initService,
  initEndpoints,
};
